module.exports = __webpack_public_path__ + "static/americancheese-a1905bcacd2a914e42c0e42c888651a4.jpg";